import {
    Component,
    DestroyRef,
    OnInit,
    ViewChild,
    inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSortModule, Sort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { UserInfo } from '../../services/user.service';
import { AppService } from '../../services/app.service';
import { SnackBarService } from '@polk_county_public_schools/ngx-pcps-dialogs/snackbar';
import { UserService } from '../../services/user.service';
import { AppStatusTable } from '../../classes/application-status-table';
import { SettingsService } from '../../services/settings.service';
import { MatDividerModule } from '@angular/material/divider';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { SchoolYearPipe } from '../../pipes/schoolyear/schoolyear.pipe';
import { MatButtonModule } from '@angular/material/button';
import { ErrorService } from '../../services/error.service';

@Component({
    selector: 'app-scholarship-count',
    templateUrl: './scholarship-count.component.html',
    imports: [
        MatTableModule,
        MatPaginatorModule,
        MatDividerModule,
        CommonModule,
        RouterModule,
        MatSortModule,
        MatInputModule,
        FormsModule,
        SchoolYearPipe,
        MatButtonModule
    ]
})
export class ScholarshipCountComponent implements OnInit {
    protected readonly destroyRef = inject(DestroyRef);
    protected readonly appSvc = inject(AppService);
    protected readonly settingSvc = inject(SettingsService);
    protected readonly snackBarSvc = inject(SnackBarService);
    protected readonly userSvc = inject(UserService);
    protected readonly errorSvc = inject(ErrorService);
    user: UserInfo;
    dataSource: MatTableDataSource<AppStatusTable>;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    displayedColumns: string[] = [
        'MasterID',
        'ScholarshipName',
        'CompletedCount',
        'OpenCount',
        'FinalistCount',
        'AwardedCount',
        'Action',
    ];
    pageSize: number;
    pageIndex: number;
    schoolYear: string;
    input: string;

    ngOnInit() {
        this.user = this.userSvc.User;
        this.getTableData();
        this.pageSize = parseInt(sessionStorage.getItem('pageSizeCount')) || 10;
        this.pageIndex = parseInt(sessionStorage.getItem('pageIndexCount')) || 0;
        this.input = sessionStorage.getItem('filterCount') || '';
        this.getSettings();
    }

    getSettings() {
        this.settingSvc.SettingsSubject.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((settings) => {
            if (settings == null) return;
            this.schoolYear = settings.find(
                (f) => f.Label === 'School year (scholarship admin)'
            ).Value;
        });
    }

    getTableData() {
        this.appSvc
            .GetStatusTable()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (res) => {
                    this.dataSource = new MatTableDataSource(res);
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.filter = this.input;
                    let sortActive = sessionStorage.getItem('activeCount') || '';
                    let sortDirection: SortDirection = sessionStorage.getItem('directionCount') as SortDirection || '';
                    this.sortChange({ active: sortActive, direction: sortDirection });
                },
                error: (error) => {
                    this.errorSvc.HandleServiceError(error);
                }
            });
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
        sessionStorage.setItem('filterCount', filterValue.trim().toLowerCase());

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    handlePageEvent(e: PageEvent) {
        this.pageSize = e.pageSize;
        sessionStorage.setItem('pageSizeCount', e.pageSize.toString());
        this.pageIndex = e.pageIndex;
        sessionStorage.setItem('pageIndexCount', e.pageIndex.toString());
    }

    sortChange(sort: Sort) {
        if (!sort.active || sort.direction === '') {
            this.dataSource.data = this.dataSource.data.slice();
            return;
        }

        sessionStorage.setItem('activeCount', sort.active);
        sessionStorage.setItem('directionCount', sort.direction);

        this.dataSource.data = this.dataSource.data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'MasterID':
                    return compare(a.MasterID, b.MasterID, isAsc);
                case 'ScholarshipName':
                    return compare(a.ScholarshipName.toLowerCase(), b.ScholarshipName.toLowerCase(), isAsc);
                case 'CompletedCount':
                    return compare(a.CompletedCount, b.CompletedCount, isAsc);
                case 'OpenCount':
                    return compare(a.OpenCount, b.OpenCount, isAsc);
                case 'FinalistCount':
                    return compare(a.FinalistCount, b.FinalistCount, isAsc);
                case 'AwardedCount':
                    return compare(a.AwardedCount, b.AwardedCount, isAsc);
                default:
                    return 0;
            }
        });
    }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}